<div class="modal-header" [ngClass]="iconTypeLayoutClass()">
  <span>{{ getTranslate("title")}}</span>
  <button class="close" aria-label="Close" (click)="closeModal()" [ngClass]="iconCustomLayoutClass()">
    <img src="/assets/images/bt-close.svg" width="28px" height="28px" />
  </button>
</div>

<div class="modal-body">
  <p>{{ getTranslate("message")}}</p>
  <p>{{ contact }}</p>
</div>

<div class="modal-footer">
  <button type="reset"
          [style.border]="'1px solid transparent'"
          (click)="closeModal()"
          class="btn btn-success small-btn"
          [ngClass]="buttonCustomLayoutCss()">
    {{ getTranslate("close")}}
  </button>
</div>
